import logo from './logo.svg';
import './App.css';
import TextRecognition from './components/TextRecognition';

function App() {
  return (
    <div className="App">
    <TextRecognition />
  </div>
  );
}

export default App;
